import * as Yup from "yup";

const ValidationLogotipo = Yup.object().shape({
  file: Yup.mixed().required('Debe seleccionar un archivo'),
});


export default ValidationLogotipo;